module.exports = __webpack_public_path__ + "fc3fd5f6870f30627c1f39867298e361.png";